import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2704cfae"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header border-0" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "row align-items-center" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "col" }, [
      /*#__PURE__*/_createElementVNode("h3", { class: "mb-0" }, "Report")
    ])
  ])
], -1))
const _hoisted_2 = { class: "card-body" }
const _hoisted_3 = { class: "pl-lg-4" }
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-lg-6" }
const _hoisted_6 = { class: "form-group" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-control-label",
  for: "search-report-start"
}, "Start date and time", -1))
const _hoisted_8 = { class: "col-lg-6" }
const _hoisted_9 = { class: "form-group" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-control-label",
  for: "search-report-end"
}, "End date and time", -1))
const _hoisted_11 = { class: "col-lg-6" }
const _hoisted_12 = { class: "form-group" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-control-label",
  for: "search-report-equipment"
}, "Equipment", -1))
const _hoisted_14 = { class: "col-lg-6" }
const _hoisted_15 = { class: "form-group" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", {
  class: "form-control-label",
  for: "search-report-type"
}, "Type", -1))
const _hoisted_17 = { class: "col-12 text-right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_n_date_picker = _resolveComponent("n-date-picker")!
  const _component_n_select = _resolveComponent("n-select")!
  const _component_n_button = _resolveComponent("n-button")!

  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(), _createElementBlock("form", { key: _ctx.reportFilter }, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _hoisted_7,
                _createVNode(_component_n_date_picker, {
                  id: "search-report-start",
                  value: _ctx.startDatetime,
                  "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.startDatetime) = $event)),
                  type: "datetime",
                  format: "yyyy-MM-dd HH:mm",
                  size: "large",
                  clearable: "",
                  "is-date-disabled": _ctx.startDateDisabled,
                  "is-time-disabled": _ctx.startTimeDisabled,
                  "on-update:show": _ctx.onStartChanged
                }, null, 8, ["value", "is-date-disabled", "is-time-disabled", "on-update:show"])
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _hoisted_10,
                _createVNode(_component_n_date_picker, {
                  id: "search-report-end",
                  value: _ctx.endDatetime,
                  "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.endDatetime) = $event)),
                  type: "datetime",
                  format: "yyyy-MM-dd HH:mm",
                  size: "large",
                  clearable: "",
                  disabled: !_ctx.startDatetime,
                  "is-date-disabled": _ctx.endDateDisabled,
                  "is-time-disabled": _ctx.endTimeDisabled,
                  "on-update:show": _ctx.onEndChanged
                }, null, 8, ["value", "disabled", "is-date-disabled", "is-time-disabled", "on-update:show"])
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _hoisted_13,
                _createVNode(_component_n_select, {
                  id: "search-report-equipment",
                  value: _ctx.reportFilter.equipment,
                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.reportFilter.equipment) = $event)),
                  options: _ctx.equipmentOptions,
                  loading: _ctx.equipmentLoading,
                  filterable: "",
                  clearable: "",
                  size: "large",
                  onSearch: _ctx.onEquipmentSearch
                }, null, 8, ["value", "options", "loading", "onSearch"])
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("div", _hoisted_15, [
                _hoisted_16,
                _createVNode(_component_n_select, {
                  id: "search-report-type",
                  value: _ctx.reportFilter.type,
                  "onUpdate:value": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.reportFilter.type) = $event)),
                  options: _ctx.typeOptions,
                  loading: _ctx.typeLoading,
                  filterable: "",
                  clearable: "",
                  size: "large",
                  onSearch: _ctx.onTypeSearch
                }, null, 8, ["value", "options", "loading", "onSearch"])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_17, [
          _createVNode(_component_n_button, {
            class: "mr-3",
            type: "primary",
            disabled: _ctx.isReportFilterEmpty(),
            onClick: _ctx.searching
          }, {
            default: _withCtx(() => [
              _createTextVNode(" SHOW RESULTS ")
            ]),
            _: 1
          }, 8, ["disabled", "onClick"]),
          _createVNode(_component_n_button, {
            strong: "",
            secondary: "",
            type: "primary",
            onClick: _ctx.reset
          }, {
            default: _withCtx(() => [
              _createTextVNode(" RESET ")
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ]))
    ])
  ]))
}